<div class="comment-widgets">

    <!-- Pagination -->
    <div *ngIf="showPagination" class="comment-row-months">
        <ngb-pagination class="d-flex-center" [collectionSize]="filter.pageTotal" [(page)]="filter.page" [pageSize]="filter.pageSize" [maxSize]="6"
            [rotate]="false" (pageChange)="onPageChange(filter.page)" size="sm">
            <ng-template ngbPaginationPrevious>
            </ng-template> <ng-template ngbPaginationNext>>
            </ng-template>
            <ng-template ngbPaginationNumber let-p>{{ getPageMonth(p) }}</ng-template>
        </ngb-pagination>
    </div>

    <!-- List -->
    <div *ngIf="source?.length">
        <div *ngFor="let givi of source">
            <div class="d-flex align-items-center comment-row" *ngIf="givi.type != 41 && givi.type != 141 && givi.type != 241">
                <div class="comment-text w-100">
                    <div>
                        <div class="font-h6">
                            #{{givi.id | number: '6.0-0'}}
                        </div>

                        <div *ngIf="givi.type == 1" class="font-c2">{{givi.productName}}</div>
                        <div *ngIf="givi.customerId == user.id && (givi.type == 41 || givi.type == 141)" class="font-c2">Envío de puntos (Regalo)</div>

                        <ng-container *ngIf="givi.type == 241" class="font-c2">
                            <div *ngIf="givi.customerOwnerId == user.id" class="font-c2">Acumulación de puntos</div>
                            <div *ngIf="givi.customerOwnerId != user.id" class="font-c2">Envío de puntos (Regalo)</div>
                        </ng-container>
                        <ng-container *ngIf="givi.type == 2 || givi.type == 7" class="font-c2">
                            <!-- Card = 1, CardPoints = 4 -->
                            <div *ngIf="givi.payType == 1" class="font-c2">{{givi.productName}}</div>
                            <div *ngIf="givi.payType == 4" class="font-c2">Gasto de puntos (Producto)</div>
                        </ng-container>

                        <ng-container *ngIf="givi.type == 3 || givi.type == 8" class="font-c2">
                            <!-- Card = 1, CardPoints = 4 -->
                            <div *ngIf="givi.payType == 1" class="font-c2">{{givi.productName}}</div>
                            <div *ngIf="givi.payType == 4" class="font-c2">Gasto de puntos (Givi POP)</div>
                        </ng-container>

                        <ng-container *ngIf="givi.type == 15 || givi.type == 35" class="font-c2">
                            <!-- Card = 1, CardPoints = 4 -->
                            <div *ngIf="givi.payType == 1" class="font-c2">{{givi.ticket?.eventObj?.name}} - {{givi.productName}}</div>
                            <div *ngIf="givi.payType == 4" class="font-c2">Gasto de puntos (Ticket)</div>
                        </ng-container>

                        <ng-container *ngIf="givi.type == 16 || givi.type == 236" class="font-c2">
                            <!-- CASHLESS = 4 -->
                            <div *ngIf="givi.payType == 1" class="font-c2">{{givi.ticket?.eventObj?.name}} - {{givi.productName}}</div>
                            <div *ngIf="givi.payType == 4" class="font-c2">Gasto de puntos (Ticket)</div>
                        </ng-container>

                        <ng-container *ngIf="givi.type == 17 || givi.type == 237" class="font-c2">
                            <!-- PASS -->
                            <div *ngIf="givi.payType == 1" class="font-c2">{{givi.ticket?.eventObj?.name}} - {{givi.productName}}</div>
                            <div *ngIf="givi.payType == 4" class="font-c2">Gasto de puntos (Ticket)</div>
                        </ng-container>


                        <div class="font-c2">{{givi.paymentAt | date: 'dd/MMM/yyyy'}}</div>
                    </div>
                </div>

                <!-- Points -->
                <div class="cursor-pointer d-flex-end align-items-center text-right" (click)="onViewEvent(givi)" style="width: 145px;">
                    <!-- givi.type
                        PurchasePoints = 1, PurchaseProducts = 2, PurchaseGiftcards = 3, PurchaseCoupons = 40, PurchaseCouponPoints = 41, PurchaseEventTickets = 15,

                        ReceivedPoints = 4, ReceivedProducts = 5, ReceivedGiftcards = 6, ReceivedCoupons = 70, ReceivedCouponPoints = 141, ReceivedEventTickets = 25,
                        
                        ExchangeProducts = 7, ExchangeGiftcards = 8, ExchangeCoupons = 9, ExchangeCouponPoints = 241, ExchangeEventTickets = 35 
                    -->
                    <div class="font-c1">
                        <!-- Purchase Points -->
                        <span *ngIf="givi.type == 1">
                            + {{givi.points}} pts
                        </span>
                        <!-- Purchase Products -->
                        <span *ngIf="givi.type == 2" class="text-black">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}<br>
                            <span *ngIf="givi.payType == 4" style="color: #753CFD;">- {{givi.points}} pts</span>
                        </span>
                        <!-- Purchase Coupons -->
                        <span *ngIf="givi.type == 70 && givi.total > 0" class="text-black">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '3.0'}}<br>
                            <span *ngIf="givi.payType == 4" style="color: #753CFD;">- {{givi.points}} pts</span>
                        </span>
                        <!-- Purchase Giftcard -->
                        <span *ngIf="givi.type == 3" class="text-black">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}<br>
                            <span *ngIf="givi.payType == 4" style="color: #753CFD;">- {{givi.points}} pts</span>
                        </span>
                        <!-- Purchase Tickets -->
                        <span *ngIf="givi.type == 15" class="text-black">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}<br>
                            <span *ngIf="givi.payType == 4" style="color: #753CFD;">- {{givi.points}} pts</span>
                        </span>
                        <!-- Purchase Cashless -->
                        <span *ngIf="givi.type == 16">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Purchase Pass -->
                        <span *ngIf="givi.type == 17">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Purchase CouponPoints -->
                        <span *ngIf="givi.customerId == user.id && givi.type == 41" style="color: #753CFD;">
                            - {{givi.points}} pts
                        </span>

                        <!-- ReceivedPoints -->
                        <span *ngIf="givi.type == 4" style="color: #753CFD;">
                            + {{givi.points}} pts
                        </span>
                        <!-- Received Product-->
                        <span *ngIf="givi.type == 5" class="text-black">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Received Giftcard-->
                        <span *ngIf="givi.type == 6" class="text-black">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Purchase CouponPoints -->
                        <span *ngIf="givi.customerId == user.id && givi.type == 141" style="color: #753CFD;">
                            - {{givi.points}} pts
                        </span>

                        <!-- Exchange Products -->
                        <span *ngIf="givi.type == 7">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Exchange Giftcards -->
                        <span *ngIf="givi.type == 8">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Exchange Tickets -->
                        <span *ngIf="givi.type == 35">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Exchange Cashless -->
                        <span *ngIf="givi.type == 236">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Exchange Pass -->
                        <span *ngIf="givi.type == 237">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '1.0'}}
                        </span>
                        <!-- Coupon Purchase -->
                        <span *ngIf="givi.type == 40">
                            {{givi.total | currency: givi?.currencySymbol : 'symbol': '3.0'}}
                        </span>
                        <!-- Exchange CouponPoints -->
                        <span *ngIf="givi.type == 241">
                            <span *ngIf="givi.customerOwnerId == user.id" style="color: #753CFD;">
                                + {{givi.points}} pts
                            </span>
                            <span *ngIf="givi.customerId == user.id" style="color: #753CFD;">
                                - {{givi.points}} pts
                            </span>
                        </span>
                    </div>
                    <i class="fa fa-chevron-right fa-2x m-l-10"></i>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!source?.length" class="p-t-20 m-l-15 text-left">
        No hay transacciones registradas.
    </div>

    <!-- Pagination -->
    <!-- <div *ngIf="showPagination" class="d-flex-end" style="padding: 20px;">
        <ngb-pagination [collectionSize]="filter.pageTotal" [(page)]="filter.page" [pageSize]="filter.pageSize" [maxSize]="4" [rotate]="true" [boundaryLinks]="true"
            (pageChange)="onPageChange(filter.page)">
        </ngb-pagination>
    </div> -->
</div>